import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-activity-target-link',
  template: `
  <a [routerLink]="'/entity/view/'+ target?.id"
  [queryParams]="{campaignId: target?.campaignContextId}"
  class="affected-user user-profile-link">
  <ng-content></ng-content>
  </a>
  `
})
export class ActivityTargetLinkComponent {
  @Input() target: {id: string; campaignContextId: string; firstName: string; middleName?: string; lastName?: string; nickName?: string; suffix?: string};
}
